module.exports = __webpack_public_path__ + "nline_items_icon.svg";